<template>
	<router-view :user="user" :isAuth="isAuth"></router-view>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/calendar/layout/Calendar.vue